import script from "./PaymentWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentWidget.vue?vue&type=script&setup=true&lang=js"

import "./PaymentWidget.vue?vue&type=style&index=0&id=8f38b61c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f38b61c"]])

export default __exports__